module.exports = __webpack_public_path__ + "img/logo-company.89747c99.png";